/**
 *
 * @module orderItem
 *
 */

import Check from 'check-types';
import Price from './price';
import Sku from './sku';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class OrderItem
 *
 */
export default class OrderItem {

    /**
     *
     * @param {SDK.Services.Commerce.Sku} sku
     * @param {SDK.Services.Commerce.Price} price
     * @throws {InvalidArgumentException}
     *
     */
    constructor(sku, price) {

        const errorMessage = {
            ctor: 'OrderItem(sku, price)',
            get sku() {
                return `${this.ctor} needs SDK.Services.Commerce.Sku instance`;
            },
            get price() {
                return `${this.ctor} needs SDK.Services.Commerce.Price instance`;
            }
        };

        instanceStrict(
            sku,
            Sku,
            errorMessage.sku,
            InvalidArgumentException
        );

        instanceStrict(
            price,
            Price,
            errorMessage.price,
            InvalidArgumentException
        );

        /**
         *
         * @access public
         * @type {SDK.Services.Commerce.Sku}
         *
         */
        this.sku = sku;

        /**
         *
         * @access public
         * @type {SDK.Services.Commerce.Price}
         *
         */
        this.price = price;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/orderItem.js